import * as Unicons from '@iconscout/react-unicons';
import { Checkbox, Drawer, Form } from 'antd';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import Logo from '../../assets/img/sidebar/logo-grande.png';
import LogoHappy from '../../assets/img/login/logo-happy.png';
import logoCB from '../../assets/img/login/logo-cb.png';
import PasswordEye from '../../components/PasswordEye';
import useLoginComponentState from './selectors/login.component.state';
import { useTranslation } from 'react-i18next';

interface TInputs {
  user: string;
  password: string;
}

export const Login = () => {
  const [eyePassword, setEyePassword] = useState<boolean>(false);
  const { state, onRealizarLogin, unidades, onClickUnidade, onToggle } =
    useLoginComponentState();
  const { register, handleSubmit } = useForm<TInputs>();
  const { t } = useTranslation('login')

  const onSubmit = async (data: TInputs) => {
    onRealizarLogin(data);
  };

  const optionsUnidade = unidades.map((unidade) => {
    return (
      <div
        onClick={() => onClickUnidade(unidade)}
        className="box-login"
        key={unidade.id}
      >
        <Unicons.UilBuilding size="30" color="#92A9CB" />
        <p>{unidade.descricao}</p>
      </div>
    );
  });

 return (
    <>
      <div className="container-login">
        <div className="formulario-box">
          <img src={Logo} alt="logo" className="logo-login" />
          <form onSubmit={handleSubmit(onSubmit)} style={{ zIndex: 3 }}>
            <div className="formulario">
              <h3>{t('login:welcome')}</h3>
              <p>{t('login:instructions')}</p>

              <div className="input">
                <Unicons.UilEnvelopeAlt size="20" color="#6A7C96" className="iconForm" />
                <Form.Item name="email" noStyle>
                  <input
                    {...register('user', { required: true })}
                    type="text"
                    id="username"
                    placeholder={t('login:emailPlaceholder')}
                  />
                </Form.Item>
              </div>

              <div className="input">
                <Unicons.UilLock size="20" color="#6A7C96" className="iconForm" />
                <input
                  {...register('password', { required: true })}
                  type={eyePassword ? 'text' : 'password'}
                  id="password"
                  placeholder={t('login:passwordPlaceholder')}
                />
                <PasswordEye eventEye={eyePassword} setEventEye={setEyePassword} />
              </div>

              <div className="lembrete">
                <Checkbox>
                  <span style={{ color: 'white' }}>{t('login:rememberMe')}</span>
                </Checkbox>
                <Link to="/senha">
                  <span id="green-happy">{t('login:forgotPassword')}</span>
                </Link>
              </div>

              <button type="submit" id="entrar" className="button-second" style={{ width: '100%', marginTop: 20 }}>
                <span>
                  {state?.flRealizandoLogin ? t('login:loading') : t('login:login')}
                </span>
              </button>

              <div className="logos-empresas">
                <img src={LogoHappy} alt="logo" className="logo-happy" />
                <img src={logoCB} alt="logo" className="logo-cb" />
              </div>
            </div>
          </form>
        </div>
        <div className="container-blue"></div>

        <Drawer title={t('login:drawerTitle')} onClose={onToggle} open={state.open} placement="top">
          <div className="boxes-login">
            <div style={{ display: 'flex', position: 'absolute' }}>{optionsUnidade}</div>
          </div>
        </Drawer>
      </div>
    </>
  );
};
